export default function CRIFunctionDirective() {
  return {
    template: require('./cri-function.html'),
    scope: {
      profileId: '=',
      criFunction: '=',
      assessment: '=',
      isEdit: '=',
      tooltipAppendToSelector: '@',
      form: '=',
    },
    controller: 'CRIFunctionController',
    controllerAs: 'criFunctionVM',
    bindToController: true,
    replace: true
  };
}
